"use client";

import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  productsToChangePrice: [],
};

const branchSettingsSlice = createSlice({
  name: "branchSettings",
  initialState,
  reducers: {
    setProductsToChangePrice(state, action) {
      // Safety fallback: if state.products is undefined (e.g. before rehydration)
      if (!Array.isArray(state.productsToChangePrice)) {
        state.productsToChangePrice = [];
      }
      const { item, isChecked, userId } = action.payload;

      const productsToChangePrice = {
        product_name: item.products.product_name,
        branch_product_id: item.branch_product_id,
        old_price: item.selling_price,
        new_price: 0,
        changed_by: userId,
      };

      if (isChecked) {
        state.productsToChangePrice.push(productsToChangePrice);
      } else {
        state.productsToChangePrice = state.productsToChangePrice.filter(
          (product) => product.branch_product_id !== item.branch_product_id
        );
      }
    },

    modifyProductsToChangePrice(state, action) {
      const { newPrice, branch_product_id } = action.payload;

      state.productsToChangePrice = state.productsToChangePrice.map((prod) =>
        prod.branch_product_id === branch_product_id
          ? { ...prod, new_price: newPrice }
          : prod
      );
    },

    removeProductsToChangePrice(state, action) {
      const { branch_product_id } = action.payload;

      state.productsToChangePrice = state.productsToChangePrice.filter(
        (prod) => {
          return prod.branch_product_id !== branch_product_id;
        }
      );
    },

    resetBranchPriceSettings(state, action) {
      return initialState;
    },
  },
});

export const {
  setProductsToChangePrice,
  removeProductsToChangePrice,
  modifyProductsToChangePrice,
  resetBranchPriceSettings,
} = branchSettingsSlice.actions;

export default branchSettingsSlice.reducer;
